package io.github.kingsword09.symbolcraft.symbols.icons.`simple-icons`.icons

import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType.Companion.NonZero
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.StrokeCap.Companion.Butt
import androidx.compose.ui.graphics.StrokeJoin.Companion.Miter
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.ImageVector.Builder
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import io.github.kingsword09.symbolcraft.symbols.icons.`simple-icons`.Icons

public val Icons.PlaystationSimpleIcons: ImageVector
    get() {
        if (_playstationSimpleIcons != null) {
            return _playstationSimpleIcons!!
        }
        _playstationSimpleIcons = Builder(name = "PlaystationSimpleIcons", defaultWidth = 24.0.dp, defaultHeight = 24.0.dp, viewportWidth = 24.0f, viewportHeight = 24.0f).apply {
            path(fill = SolidColor(Color(0xFF000000)), stroke = null, strokeLineWidth = 0.0f, strokeLineCap = Butt, strokeLineJoin = Miter, strokeLineMiter = 4.0f, pathFillType = NonZero) {
                moveTo(8.98f, 2.60f)
                verticalLineToRelative(17.55f)
                lineToRelative(3.92f, 1.26f)
                lineTo(12.90f, 6.69f)
                curveToRelative(0.0f, -0.69f, 0.30f, -1.15f, 0.79f, -0.99f)
                curveToRelative(0.64f, 0.18f, 0.76f, 0.81f, 0.76f, 1.51f)
                verticalLineToRelative(5.88f)
                curveToRelative(2.44f, 1.19f, 4.36f, -0.00f, 4.36f, -3.15f)
                curveToRelative(0.0f, -3.24f, -1.13f, -4.68f, -4.44f, -5.83f)
                curveToRelative(-1.31f, -0.45f, -3.73f, -1.19f, -5.39f, -1.50f)
                close()
                moveTo(13.64f, 18.84f)
                lineToRelative(6.30f, -2.28f)
                curveToRelative(0.72f, -0.26f, 0.83f, -0.63f, 0.25f, -0.82f)
                curveToRelative(-0.59f, -0.19f, -1.64f, -0.14f, -2.36f, 0.12f)
                lineToRelative(-4.21f, 1.5f)
                lineTo(13.62f, 14.98f)
                lineToRelative(0.24f, -0.09f)
                reflectiveCurveToRelative(1.20f, -0.42f, 2.91f, -0.62f)
                curveToRelative(1.70f, -0.18f, 3.79f, 0.03f, 5.44f, 0.66f)
                curveToRelative(1.85f, 0.60f, 2.04f, 1.47f, 1.58f, 2.07f)
                curveToRelative(-0.47f, 0.6f, -1.62f, 1.04f, -1.62f, 1.04f)
                lineToRelative(-8.54f, 3.11f)
                lineTo(13.62f, 18.86f)
                close()
                moveTo(1.81f, 18.6f)
                curveToRelative(-1.9f, -0.55f, -2.21f, -1.67f, -1.35f, -2.32f)
                curveToRelative(0.80f, -0.59f, 2.16f, -1.05f, 2.16f, -1.05f)
                lineToRelative(5.62f, -2.01f)
                verticalLineToRelative(2.31f)
                lineTo(4.21f, 17.0f)
                curveToRelative(-0.71f, 0.27f, -0.83f, 0.63f, -0.24f, 0.83f)
                curveToRelative(0.59f, 0.20f, 1.64f, 0.15f, 2.34f, -0.12f)
                lineTo(8.25f, 17.0f)
                verticalLineToRelative(2.07f)
                curveToRelative(-0.12f, 0.03f, -0.26f, 0.04f, -0.39f, 0.07f)
                curveToRelative(-1.94f, 0.33f, -4.00f, 0.20f, -6.04f, -0.48f)
                close()
            }
        }
        .build()
        return _playstationSimpleIcons!!
    }

private var _playstationSimpleIcons: ImageVector? = null
